<template>
    <div class="splash-bg">
        <div class="splash-content">
            <div class="h-100 d-flex justify-content-between flex-column">
                <div class="d-block m-auto text-center">
                    <img width="150px" src="../../assets/img/login.svg" class="img-fluid">
                    <h1 class="text-center mt-4 mb-2">How do you want to proceed?</h1>
                </div>

                <div class="d-flex flex-column">
                    <router-link :to="{name: 'login'}" class="btn btn-primary btn-lg">Login</router-link>
                    <br>
                    <router-link :to="{name: 'register'}" class="btn btn-outline-primary btn-lg">Register</router-link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Splash"
    }
</script>

<style scoped>

</style>